import { Component, ViewChild, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { confirmPassword } from "src/app/core/utils/utils";
import { ApiService } from "src/app/core/services/api.service";
import { ToastService } from "src/app/core/services/toast.service";
import { ImageCroppedEvent, LoadedImage } from "ngx-image-cropper";
import { User } from "src/app/core/endpoints/models/user.model";
import { AuthService } from "src/app/core/endpoints/auth.service";

@Component({
  selector: "app-my-data",
  templateUrl: "./my-data.component.html",
  styleUrls: ["./my-data.component.scss"],
})
export class MyDataComponent implements OnInit {
  @ViewChild("fileInput") fileInput: any;

  public user: User = null;
  public loading: boolean = false;
  public confirmUpdateDialog: boolean = false;
  public newEmail: string;
  public newName: string;
  public newSurname: string;
  public photo: File;
  public stringPhoto: any = "";

  public form: FormGroup = this.fb.group({
    user_id: [null],
    name: ["", [Validators.required, Validators.pattern("^[a-zA-ZÁáÉéÍíÓóÚúÑñ1234567890 ]*$")]],
    phone: ["", Validators.pattern(/^\+[0-9 ]+$/)],
    email: ["", [Validators.required, Validators.email]],
    password: [""],
    password_confirmation: [""],
    role_id: [""],
    avatar: [""],
  });

  imageChangedEvent: Event | null = null;
  croppedActive: boolean = false;

  constructor(
    private fb: FormBuilder,
    protected toast: ToastService,
    private apiService: ApiService
  ) {
    this.getUser();
  }

  ngOnInit() {
  }

  /**
   * Obtener los datos del usuario actual y configurar el formulario según su rol.
   */
  public getUser() {
    this.apiService.getEntity("user").subscribe({
      next: (result) => {
        this.user = result.user;
        this.form.patchValue(this.user);
        this.form.patchValue({ 
			user_id: this.user.id,
			role_id: this.user.role_id,
		});
        if (this.user.avatar) {
          this.stringPhoto = this.user.avatar;
        }
        if (this.user.role_id === 1) {
          this.form.get("password_confirmation")?.setValidators([confirmPassword]);
          this.form.get("password_confirmation")?.updateValueAndValidity();
        } else if (this.user.role_id === 2) {
          this.form.get("password")?.clearValidators();
          this.form.get("password")?.updateValueAndValidity();
          this.form.get("password_confirmation")?.clearValidators();
          this.form.get("password_confirmation")?.updateValueAndValidity();
        }
        AuthService.setDataUser(result.user);
      },
      error: (err) => {
        this.user = JSON.parse(localStorage.getItem("dataUserWeb"));
      },
      complete: () => {},
    });
  }

  /**
   * Enviar el formulario para actualizar el perfil.
   */
  public async saveUser() {
    const message1 = "Aviso";
    const message2 = "Faltan datos en el formulario";
    const message3 = "Introduzca número de teléfono con formato correcto";
    if (this.user.role_id === 1 || this.user.role_id === 2) {
      if (
        this.form.get("name")?.value === "" ||
        this.form.get("email")?.value === "" ||
        (this.user.role_id === 1 &&
          this.form.get("password")?.value !== this.form.get("password_confirmation")?.value)
      ) {
        return this.toast.show(message1, message2, "warn");
      }
    } else if (this.user.role_id === 3) {
      if (this.form.get("phone")?.value === "") {
        return this.toast.show(message1, message3, "warn");
      }
      if (this.form.invalid) {
        return this.toast.show(message1, message2, "warn");
      }
    }

    this.loading = true;
    this.form.patchValue({ avatar: this.stringPhoto });

    this.apiService.updateEntity("updateUserFromAdmin", this.user.id, this.form.value).subscribe({
      next: (result) => {
        this.loading = false;
        this.toast.show("Datos actualizados correctamente");
        this.getUser();
        this.confirmUpdateDialog = false;
        this.croppedActive = false;
      },
      error: (err) => {
        this.loading = false;
        let message = "Ocurrió un error al editar el usuario, inténtelo de nuevo";
        if (err && err.error && err.error.errors) {
          message = "";
          let errors = err.error.errors;
          for (const field in errors) {
            errors[field].forEach((errorMessage) => {
              message += `${errorMessage}\n`;
            });
          }
        }
        this.toast.show("Error", message, "error");
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  public handleConfirmUpdate() {
    this.confirmUpdateDialog = true;
    if (this.form.get("email")?.value) {
      this.newEmail = this.form.get("email")?.value;
    }
    if (this.form.get("name")?.value) {
      this.newName = this.form.get("name")?.value;
    }
  }

  public handleUpload($event: any) {
    this.imageChangedEvent = $event;
    this.croppedActive = true;
  }

  public deletePhoto() {
    this.stringPhoto = undefined;
    this.croppedActive = false;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.stringPhoto = event.base64;
  }
  imageLoaded(image: LoadedImage) {}
  cropperReady() {}
  loadImageFailed() {}
}
